import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { IPLDataUpload } from './ipl-data-upload';

export type IIPLWorkflowConnectProps = ReactRedux.DispatchProp<Redux.Action>;

export const IPLDataUploadContainer: React.ComponentClass
  = ReactRedux.connect()(IPLDataUpload);
